// import React, { useState } from "react";

// type SidebarContextObj = { isOpen: boolean; toggleSidebar: () => void };

// const SidebarContext = React.createContext<SidebarContextObj>({
//   isOpen: true,
//   toggleSidebar: () => {},
// });

// export const SidebarContextProvider: React.FC = (props) => {
//   const [isOpen, setIsOpen] = useState(true);
//   function ToggleSidebar() {
//     setIsOpen((prev) => !prev);
//   }

//   const contextValue: SidebarContextObj = {
//     isOpen,
//     toggleSidebar: ToggleSidebar,
//   };
//   return (
//     <SidebarContext.Provider value={contextValue}>
//       {props.children}
//     </SidebarContext.Provider>
//   );
// };

// export default SidebarContext;

import React, { useState, ReactNode } from "react";

type SidebarContextObj = { isOpen: boolean; toggleSidebar: () => void };

const SidebarContext = React.createContext<SidebarContextObj>({
  isOpen: true,
  toggleSidebar: () => {},
});

type SidebarProviderProps = {
  children: ReactNode;
};

export const SidebarContextProvider: React.FC<SidebarProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  function ToggleSidebar() {
    setIsOpen((prev) => !prev);
  }

  const contextValue: SidebarContextObj = {
    isOpen,
    toggleSidebar: ToggleSidebar,
  };
  return (
    <SidebarContext.Provider value={contextValue}>
      {children}
    </SidebarContext.Provider>
  );
};

export default SidebarContext;